import Grid from "@mui/material/Grid";
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";
import Container from "@mui/material/Container";
import KnowledgeDocumentForm from "../components/KnowledgeDocumentForm";

function NewKnowledgeDocument() {
  return (
    <MKBox component="section" py={12}>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MKTypography variant="h3" gutterBottom>
              Maak een nieuw kennis document aan
            </MKTypography>
            <MKTypography variant="body2" fontWeight="regular" color="text">
              Een kennis document is een document dat informatie bevat over een bepaald onderwerp.
              Het kan bijvoorbeeld een handleiding, een technische specificatie of een andere
              relevante informatie zijn.
            </MKTypography>
          </Grid>
          <Grid item xs={12}>
            <KnowledgeDocumentForm />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default NewKnowledgeDocument;
